'use strict';

$.fn.cycle.transitions.large = {
	postInit: function postInit(opts) {
		this.pagerPosition(opts);
	},
	before: function before(opts, curr, next, fwd) {
		var css = opts.API.getSlideOpts(opts.nextSlide).slideCss || {};
		opts.API.stackSlides(curr, next, fwd);
		opts.cssBefore = $.extend(css, { opacity: 0, visibility: 'visible', display: 'block' });
		opts.animIn = { opacity: 1 };
		opts.animOut = { opacity: 0 };
		this.pagerPosition(opts, next);
	},
	after: function after(opts, currEl, nextEl, fwdFlag) {},
	pagerPosition: function pagerPosition(opts, next) {
		var captionHeight;
		if (next) {
			captionHeight = $(next).find('.cycle-caption').outerHeight();
		} else {
			captionHeight = opts.container.find('.cycle-slide-active .cycle-caption').outerHeight();
		}
		opts.container.next('.cycle-controls').find('.cycle-pager').css('margin-top', captionHeight / 2 + 20);
	}
};